module.exports = __webpack_public_path__ + "img/mobile-login-background.9d13c5ba.svg";